class WaGolfLive extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.abort = new AbortController();
    this.cache = {};
    this.ready = false;
    this.busy = false;
    this.approval = null;
    this.$ = selector => this.querySelector(selector);
    this.msg = JSON.parse(this.$('[data-messages]').textContent);
    this.form = this.$('form');
    this.canvas = this.$('[data-banner]');
    this.ctx = this.canvas.getContext('2d');
    this.dialog = this.$('dialog');
    this.addLabel = this.$('[data-add]').textContent;
    this.storageKey = `wa-golf-product-${this.dataset.product}-v1`;
    this.state = {name: '', motto: 'ONE MORE ROUND.', year: this.$('[name="year"]').value, showYear: true, color: 'forest'};
    try {
      const saved = JSON.parse(localStorage.getItem(this.storageKey));
      if (saved && typeof saved.name === 'string' && typeof saved.motto === 'string' && typeof saved.year === 'string' && ['forest'].includes(saved.color)) {
        this.state = {name: saved.name.slice(0,28), motto: saved.motto.slice(0,36), year: saved.year.slice(0,4), showYear: !!saved.showYear, color: saved.color};
      }
    } catch {}
    for (const key of ['name','motto','year']) this.$(`[name="${key}"]`).value = this.state[key];
    this.$('[name="showYear"]').checked = this.state.showYear;
    
    const listen = (target, name, handler) => target.addEventListener(name, handler, {signal: this.abort.signal});
    listen(this.form, 'input', () => this.update());
    listen(this.form, 'submit', event => { event.preventDefault(); this.review(); });
    listen(this.$('[data-zoom]'), 'click', () => this.review());
    for (const selector of ['[data-close]','[data-edit]']) listen(this.$(selector), 'click', () => { if (!this.busy) this.dialog.close(); });
    listen(this.dialog, 'cancel', event => { if (this.busy) event.preventDefault(); });
    listen(this.$('[data-confirm]'), 'change', () => this.updateCheckout());
    listen(this.$('[data-add]'), 'click', () => this.addToCart());
    listen(this.$('[data-reset]'), 'click', () => { this.form.reset(); this.update(); });
    listen(this.form, 'focusin', event => this.classList.toggle('is-typing', event.target.matches('input[type="text"]')));
    listen(this.form, 'focusout', () => this.classList.remove('is-typing'));
    listen(window, 'pageshow', () => { this.setBusy(false); });
    this.update();
    this.initialize();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.started = false;
  }
  async initialize() {
    try {
      const font = new FontFace('WaGolfSerif', `url(${this.dataset.font})`, {weight:'700'});
      await font.load();
      document.fonts.add(font);
      const loadImage = src => new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
      });
      [this.art, this.room] = await Promise.all([loadImage(this.dataset.art), loadImage(this.dataset.room)]);
      if (!this.isConnected || this.abort.signal.aborted) return;
      this.ready = true;
      this.$('[data-status]').textContent = '';
      this.update();
    } catch {
      if (this.isConnected) this.$('[data-status]').textContent = this.msg.load_error;
    }
  }
  values() {
    const showYear = this.$('[name="showYear"]').checked;
    return {
      name: this.$('[name="name"]').value.normalize('NFKC').trim().toUpperCase().replace(/['’]S$/, '').trim(),
      motto: this.$('[name="motto"]').value.normalize('NFKC').trim().toUpperCase(),
      year: showYear ? this.$('[name="year"]').value.trim() : '',
      showYear,
      color: 'forest'
    };
  }
  heading() { return (this.state.name || this.msg.sample_name) + '’S 19TH HOLE'; }
  update() {
    const state = this.values();
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.approval = null;
      this.$('[data-confirm]').checked = false;
      this.$('[data-review-status]').textContent = '';
      this.$('[data-cart-link]').hidden = true;
    }
    this.state = state;
    const year = this.$('[name="year"]');
    year.disabled = !state.showYear;
    year.required = state.showYear;
    year.setCustomValidity(state.showYear && !/^[0-9]{4}$/.test(state.year) ? this.msg.year_invalid : '');
    const nameValid = /^[A-ZÀ-ÖØ-Þ0-9 .,'’&-]+$/u.test(state.name) && state.name.length <= 28;
    const mottoValid = /^[A-ZÀ-ÖØ-Þ0-9 .,'’&!?:;()+/—–-]+$/u.test(state.motto) && state.motto.length <= 36;
    this.$('[name="name"]').setCustomValidity(!state.name ? this.msg.required : nameValid ? '' : this.msg.name_characters);
    this.$('[name="motto"]').setCustomValidity(!state.motto ? this.msg.required : mottoValid ? '' : this.msg.motto_characters);
    
    this.$('[data-name-count]').textContent = `${this.$('[name="name"]').value.length}/28`;
    this.$('[data-motto-count]').textContent = `${this.$('[name="motto"]').value.length}/36`;
    for (const button of this.querySelectorAll('[data-needs-ready]')) button.disabled = !this.ready || this.busy;
    this.$('[data-review]').disabled = !this.ready || this.busy || this.dataset.available !== 'true';
    this.canvas.setAttribute('aria-label', [this.heading(), this.msg[state.color], state.motto, state.showYear ? 'EST. ' + state.year : '', this.msg.scene].filter(Boolean).join(' — '));
    try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch {}
    if (this.ready) this.drawScene(this.ctx);
    else { this.ctx.fillStyle = '#161715'; this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height); }
    this.updateCheckout();
  }
  updateCheckout() {
    this.$('[data-add]').disabled = this.busy || !this.ready || !this.$('[data-confirm]').checked || this.dataset.available !== 'true';
  }
  setBusy(value) {
    this.busy = value;
    this.form.inert = value;
    this.dialog.setAttribute('aria-busy', String(value));
    for (const selector of ['[data-close]','[data-edit]','[data-confirm]']) this.$(selector).disabled = value;
    this.$('[data-add]').textContent = value ? this.msg.adding : this.addLabel;
    this.updateCheckout();
  }
  text(c,text,y,size,maxWidth,color,center=840){
    if(!text)return;let f=size;c.textAlign='center';c.textBaseline='alphabetic';
    c.font=`${f}px WaGolfSerif`;while(c.measureText(text).width>maxWidth&&f>24){f--;c.font=`${f}px WaGolfSerif`;}
    c.fillStyle=color;c.fillText(text,center,y);
  }
  draw(c,mockup=false){
    c.save();c.fillStyle='#102c22';c.fillRect(0,0,1680,1035);c.drawImage(this.art,0,0,1680,1035);
    this.text(c,(this.state.name||this.msg.sample_name)+'’S',210,164,1200,'#f0d4a6',990);
    this.text(c,'19TH HOLE',308,86,1030,'#f0d4a6',990);
    c.strokeStyle='#d2a14b';c.lineWidth=2;c.beginPath();c.moveTo(575,281);c.lineTo(650,281);c.moveTo(1330,281);c.lineTo(1405,281);c.stroke();
    if(this.state.showYear)this.text(c,'EST. '+this.state.year,944,34,600,'#f0d4a6');
    this.text(c,this.state.motto||'ONE MORE ROUND.',993,28,1260,'#d6ab62');
    if(mockup){c.strokeStyle='#183b2d';c.lineWidth=8;c.strokeRect(4,4,1672,1027);c.setLineDash([5,5]);c.lineWidth=1;c.strokeStyle='#b99550';c.strokeRect(16,16,1648,1003);c.setLineDash([]);for(const y of [47,988]){c.beginPath();c.arc(34,y,12,0,Math.PI*2);c.fillStyle='#b3a273';c.fill();c.beginPath();c.arc(34,y,7.5,0,Math.PI*2);c.fillStyle='#30322d';c.fill();}}
    c.restore();
  }
  drawScene(c){
    c.save();c.clearRect(0,0,1536,1024);c.drawImage(this.room,200,0,1200,800,0,0,1536,1024);
    const x=241,y=35,w=1100,h=w*34.5/56;
    const fabric=document.createElement('canvas');fabric.width=1680;fabric.height=1035;const fc=fabric.getContext('2d');this.draw(fc,true);
    const light=fc.createLinearGradient(0,0,1680,1035);light.addColorStop(0,'#ffffff15');light.addColorStop(.4,'#ffffff00');light.addColorStop(1,'#00000020');fc.fillStyle=light;fc.fillRect(0,0,1680,1035);
    fc.lineWidth=1;fc.strokeStyle='#ffffff06';fc.beginPath();for(let row=2;row<1035;row+=4){fc.moveTo(0,row);fc.lineTo(1680,row);}fc.stroke();
    c.shadowColor='#00000060';c.shadowBlur=15;c.shadowOffsetX=4;c.shadowOffsetY=8;c.fillStyle='#171815';c.fillRect(x,y,w,h);c.shadowColor='transparent';
    for(let col=0;col<1680;col+=4){const offset=Math.sin(col/1680*Math.PI*4)*1.15;c.drawImage(fabric,col,0,4,1035,x+col*w/1680,y+offset,4*w/1680+.3,h);}
    for(const at of [.035,.5,.965]){const cx=x+w*at;c.fillStyle='#181a19';c.shadowColor='#0006';c.shadowBlur=3;c.shadowOffsetY=2;c.fillRect(cx-8,y-4,16,12);c.shadowColor='transparent';c.strokeStyle='#747771';c.lineWidth=1.3;c.beginPath();c.moveTo(cx-4,y-4);c.lineTo(cx-4,y-13);c.quadraticCurveTo(cx,y-19,cx+4,y-13);c.lineTo(cx+4,y-4);c.stroke();}
    c.restore();
  }
  review() {
    if (this.busy || !this.ready || !this.form.reportValidity()) return;
    const canvas = this.$('[data-large]');
    this.drawScene(canvas.getContext('2d'));
    canvas.setAttribute('aria-label', this.canvas.getAttribute('aria-label'));
    this.$('[data-summary]').textContent = [this.heading(), this.msg[this.state.color], this.state.showYear ? 'EST. ' + this.state.year : this.msg.no_year, this.state.motto].join(' · ');
    this.updateCheckout();
    this.dialog.showModal();
  }
  prepareApproval() {
    const fingerprint = JSON.stringify(this.state);
    if (this.approval?.fingerprint === fingerprint) return this.approval;
    const canvas = this.$('[data-large]');
    this.drawScene(canvas.getContext('2d'));
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    this.approval = {
      fingerprint,
      token: Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join(''),
      payload: JSON.stringify({configuration: {...this.state}, proof_b64: canvas.toDataURL('image/png').split(',')[1], approved: true}),
      saved: null,
      cartUncertain: false
    };
    return this.approval;
  }
  async request(url, options = {}, timeout = 25000) {
    const controller = new AbortController();
    const abort = () => controller.abort();
    this.abort.signal.addEventListener('abort', abort, {once:true});
    const timer = setTimeout(abort, timeout);
    try {
      return await fetch(url, {...options, signal: controller.signal});
    } finally {
      clearTimeout(timer);
      this.abort.signal.removeEventListener('abort', abort);
    }
  }
  async saveApproval(approval) {
    if (approval.saved) return approval.saved;
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const response = await this.request(this.dataset.endpoint, {
          method: 'POST',
          headers: {'Content-Type':'application/json', 'X-Submission-Token':approval.token},
          body: approval.payload
        }, 45000);
        if (!response.ok) {
          const error = new Error(this.msg.save_error);
          error.retryable = response.status >= 500 || response.status === 429;
          throw error;
        }
        const result = await response.json();
        if (!result.submission_id || !result.configuration || !result.config_url || !result.proof_url || JSON.stringify(result.configuration) === '{}') throw new Error(this.msg.save_error);
        const config = result.configuration;
        if (config.name !== this.state.name || config.motto !== this.state.motto || config.color !== this.state.color || config.year !== this.state.year || config.showYear !== this.state.showYear) throw new Error(this.msg.save_error);
        approval.saved = result;
        return result;
      } catch (error) {
        if (this.abort.signal.aborted) throw error;
        if (attempt === 0 && (error.retryable || error.name === 'TypeError' || error.name === 'AbortError')) continue;
        throw new Error(this.msg.save_error);
      }
    }
  }
  async cartContains(submissionId) {
    try {
      const response = await this.request(this.dataset.cartUrl + '.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error();
      return cart.items.some(item => String(item.variant_id) === this.dataset.variant && item.properties?.['_Wallanthem submission'] === submissionId);
    } catch {
      throw new Error(this.msg.cart_check_error);
    }
  }
  properties(saved) {
    const config = saved.configuration;
    return {
      [this.msg.property_name]: config.name,
      [this.msg.property_color]: this.msg.forest,
      [this.msg.property_year]: config.showYear ? config.year : this.msg.no_year,
      [this.msg.property_motto]: config.motto,
      [this.msg.property_approval]: this.msg.approved,
      '_Wallanthem submission': saved.submission_id,
      '_Configuration': saved.config_url,
      '_Preview': saved.proof_url
    };
  }
  async addToCart() {
    if (this.busy || !this.ready || this.dataset.available !== 'true' || !this.form.reportValidity()) return;
    if (!this.$('[data-confirm]').checked) {
      this.$('[data-review-status]').textContent = this.msg.confirmation_required;
      this.$('[data-confirm]').focus();
      return;
    }
    this.setBusy(true);
    this.$('[data-cart-link]').hidden = true;
    this.$('[data-review-status]').textContent = this.msg.saving;
    try {
      const approval = this.prepareApproval();
      const saved = await this.saveApproval(approval);
      this.$('[data-review-status]').textContent = this.msg.adding;
      if (await this.cartContains(saved.submission_id)) {
        window.location.assign(this.dataset.cartUrl);
        return;
      }
      if (approval.cartUncertain) throw new Error(this.msg.cart_uncertain);
      let response;
      try {
        response = await this.request(this.dataset.cartAddUrl, {
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:[{id:Number(this.dataset.variant), quantity:1, properties:this.properties(saved)}]})
        });
      } catch {
        approval.cartUncertain = true;
        if (await this.cartContains(saved.submission_id)) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        throw new Error(this.msg.cart_uncertain);
      }
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(typeof error.description === 'string' ? error.description : this.msg.cart_error);
      }
      approval.cartUncertain = true;
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      if (!this.isConnected || this.abort.signal.aborted) return;
      this.$('[data-review-status]').textContent = error.message || this.msg.cart_error;
      this.$('[data-cart-link]').hidden = false;
    } finally {
      if (this.isConnected) this.setBusy(false);
    }
  }
}
if (!customElements.get('wa-golf-live')) customElements.define('wa-golf-live', WaGolfLive);

